import { render } from "./ChartBar.vue?vue&type=template&id=17da1a9e"
import script from "./ChartBar.vue?vue&type=script&lang=js"
export * from "./ChartBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/ChartBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17da1a9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17da1a9e', __exports__)) {
    api.reload('17da1a9e', __exports__)
  }
  
  module.hot.accept("./ChartBar.vue?vue&type=template&id=17da1a9e", () => {
    api.rerender('17da1a9e', render)
  })

}


export default __exports__